import { normalizeFields } from "@/forms/helpers";
import { createUserNewsletterModel } from "@/forms/form-types/user-model";

export function createFormFields(
  newsletter: boolean,
  isNewsletterRequired: boolean,
) {
  return normalizeFields({
    ...(!newsletter ? createUserNewsletterModel(isNewsletterRequired) : {}),
  });
}
